import React from "react";
import { useTranslation } from "react-i18next";
import { CHIP_TONES } from "./FilterChips";

// Question statuses in the order a question goes through them.
export const STATUS_ORDER = ["DRAFT", "PENDING_REVIEW", "UNDER_REVIEW", "CHANGES_REQUESTED", "RESUBMITTED", "APPROVED", "DECLINED", "ARCHIVED"];

// Older backends only send the English name (and the status uuid).
const LEGACY_STATUS_CODES = {
  Draft: "DRAFT",
  "Pending Review": "PENDING_REVIEW",
  "Under Review": "UNDER_REVIEW",
  "Changes Requested": "CHANGES_REQUESTED",
  Resubmitted: "RESUBMITTED",
  Approved: "APPROVED",
  Declined: "DECLINED",
  Archived: "ARCHIVED",
};

// The colors of each status (badge, filter chip and its dot).
export const STATUS_TONES = {
  DRAFT: CHIP_TONES.slate,
  PENDING_REVIEW: CHIP_TONES.amber,
  UNDER_REVIEW: CHIP_TONES.blue,
  CHANGES_REQUESTED: CHIP_TONES.violet,
  RESUBMITTED: CHIP_TONES.cyan,
  APPROVED: CHIP_TONES.green,
  DECLINED: CHIP_TONES.red,
  ARCHIVED: CHIP_TONES.slate,
};
const UNKNOWN_TONE = STATUS_TONES.ARCHIVED;
export const statusTone = (code) => STATUS_TONES[code] || UNKNOWN_TONE;

// The status code of a status_count item: status_code, else the status list (by uuid), else the English name.
export const statusCountCode = (item, codeByUuid) =>
  item?.status_code || codeByUuid?.get(item?.status_uuid) || LEGACY_STATUS_CODES[item?.status] || null;

export const statusText = (t, code, name) =>
  code ? t(`questions_page.status.${code.toLowerCase()}`, { defaultValue: name || code }) : name || "";

// A question's status ({code, name}) as a pill.
export function QuestionStatusBadge({ status, className = "" }) {
  const [t] = useTranslation();
  if (!status?.name && !status?.code) return null;
  const code = status.code || LEGACY_STATUS_CODES[status.name];
  return (
    <span
      className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${
        statusTone(code).badge
      } ${className}`}
    >
      {statusText(t, code, status.name)}
    </span>
  );
}
